import { useContext } from "react"
import SideMenuContext from "context/SideMenuContext"

const useSideMenuContext = () => useContext(SideMenuContext)

export default useSideMenuContext